interface Props {
    value: string;
    isView?: boolean;
}

export default function RichTextViewer({ value, isView = false }: Props) {
    const isEmpty = !value || value.trim() === "";

    return (
        <div className="overflow-hidden rounded-md border border-gray-200 bg-gray-50">
            <div className="rich-text-viewer bg-white px-3 py-3">
                {isEmpty ? (
                    <span className="text-gray-400 text-xs">
                        {isView
                            ? "No content available."
                            : "Your formatted content will appear here..."}
                    </span>
                ) : (
                    <div
                        className="text-[13px]"
                        dangerouslySetInnerHTML={{
                            __html: value,
                        }}
                    />
                )}
            </div>
        </div>
    )
}
